import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/BannerCollection/SaleBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/Desktop/AppDirAvatarSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/Desktop/DesktopHeaderSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/MicroBanner/AppDirMicroBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/Mobile/AppDirMobileHeaderSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/Mobile/AppDirMobileLeftNavButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/Mobile/AppDirMobileNavOverlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/AppDir/Header/Mobile/MobileRightNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/Chrome/FooterEmailCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/Chrome/Header/Desktop/DesktopHeaderCmsNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/Chrome/Header/Mobile/LeftNavCmsNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/Chrome/TrustpilotFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/components/Links/GooglePlayStoreLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/components/Links/IosAppStoreLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/components/LoginRegister/ManagedLoginRegisterModal.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/components/MobileMenuItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNavProvider"] */ "/app/apps/web/contexts/MobileNavContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/public/static/ios-app-store.png");
;
import(/* webpackMode: "eager" */ "/app/apps/web/public/static/missing-avatar.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/public/static/svg/CartIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/public/static/svg/FavoriteIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwapsIcon"] */ "/app/apps/web/public/static/svg/ItemActionIcons.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/public/static/svg/PlayStoreIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/public/static/svg/ReferralDollar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstagramIcon","FacebookIcon","YoutubeIcon","TwitterIcon","TikTokIcon"] */ "/app/apps/web/public/static/svg/SocialIcons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/public/static/svg/WarningIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@headlessui+react@2.2.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/@headlessui/react/dist/components/popover/popover.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.4_@babel+core@7.26.7_@opentelemetry+api@1.8.0_@playwright+test@1.48.2_babel-plugin-_kxbk52bfyivyx4465i4twzmiwe/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.4_@babel+core@7.26.7_@opentelemetry+api@1.8.0_@playwright+test@1.48.2_babel-plugin-_kxbk52bfyivyx4465i4twzmiwe/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.4_@babel+core@7.26.7_@opentelemetry+api@1.8.0_@playwright+test@1.48.2_babel-plugin-_kxbk52bfyivyx4465i4twzmiwe/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["LogoTagline"] */ "/app/packages/common-nextjs/src/assets/LogoTagline.tsx");
